module.exports = __webpack_public_path__ + "static/media/logo-lunch-team.39366e62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-lunch-team.svg
// module id = 313
// module chunks = 5